// extracted by mini-css-extract-plugin
export default {"container":"dashBoard_container__q9TOe","result":"dashBoard_result__s1IAt"};